















































import Analytics from '@/services/Analytics'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    mounted() {
        // Add Click Event Listener
        document.addEventListener('click', this.outClick)
    },
    beforeDestroy() {
        // Remove Click Event Listener
        document.removeEventListener('click', this.outClick)
    },
    computed: {
        ...mapGetters({
            isApp: 'isApp',
            subscription: 'subscription',
            tenant: 'tenant',
            user: 'user'
        }),
        helpModalStyle(): object {
            return {
                position: 'fixed',
                height: this.tenant.account_status == 'active' ? '400px' : '400px',
                width: '350px',
                bottom: '35px',
                left: this.$store.getters.appDrawer ? '210px' : '20px',
                background: '#6142b0',
                'border-radius': '10px',
                'z-index': 4,
                display: 'flex',
                'justify-content': 'center',
                'flex-direction': 'column',
                margin: '0px',
                'font-weight': 400
            }
        },
        mobileStyle(): object {
            return {
                position: 'fixed',
                height: '100%',
                width: '100%',
                top: '0px',
                left: '0px',
                background: '#6142b0',
                'border-radius': '10px',
                'z-index': 5,
                display: 'flex',
                'justify-content': 'center',
                'flex-direction': 'column',
                margin: '0px',
                'font-weight': 400
            }
        },
        modalItems(): object {
            const items = [
                {
                    header: 'Find Answers:',
                    buttons: [
                        {
                            icon: 'bi-mortarboard',
                            text: 'Getting Started Guide',
                            link: 'https://learn.messagedesk.com/en/collections/3509306-getting-started-in-messagedesk'
                        },
                        {
                            icon: 'bi-mortarboard',
                            text: 'Learning Center',
                            link: 'https://learn.messagedesk.com/en/'
                        }
                    ]
                },
                // {
                //     header: 'Chat With Us:',
                //     buttons: [
                //         // {
                //         //     icon: 'bi-chat-square-dots-fill',
                //         //     text: 'Chat with Us',
                //         //     intercom: true
                //         // },
                //         {
                //             icon: 'bi-calendar2-plus',
                //             text: 'Schedule a Meeting',
                //             tenantActive: this.tenant.account_status == 'active',
                //             link: 'https://messagedesk.typeform.com/to/owZOnWC2'
                //         }
                //     ]
                // },
                // {
                //     header: 'Leave Feedback:',
                //     buttons: [
                //         // {
                //         //     icon: 'bi-bug',
                //         //     id: 'report-a-bug',
                //         //     text: 'Report a Bug',
                //         //     link: null
                //         // },
                //         // {
                //         //     icon: 'bi-lightbulb-fill',
                //         //     id: 'suggest-a-feature',
                //         //     text: 'Suggest a Feature',
                //         //     link: null
                //         // },
                //         {
                //             icon: 'bi-star-fill',
                //             text: 'Leave a Review',
                //             link: 'https://www.g2.com/products/messagedesk/reviews/start?return_to=https%3A%2F%2Fwww.g2.com%2Fproducts%2Fmessagedesk%2Ftake_survey'
                //         },
                //         {
                //             icon: 'bi-cash',
                //             text: 'Refer Friends, Get Rewards',
                //             route: '/referral'
                //         }
                //     ]
                // }
            ]

            return items
        },
        userName(): string {
            //  Grab the current user
            const user = this.user

            //  Grab their name
            const name = user.firstname

            //  Grab their email
            const email = user.email

            //  If there is no name OR if the email === name, then return 'there'
            if (!name || name === email) return 'there'

            //  Check the length of our name
            const len = name.length

            //  If the name is over 15 characters, just return 'there'
            if (len >= 15) return 'there'

            //  Else, we are good so just return their name
            return name
        }
    },
    methods: {
        close(): void {
            // Close help modal component
            this.$store.commit('helpModalSet', false)
        },
        linkClick(btn): void {
            //  Grab the link from this button
            const link = btn.link

            //  Report track data to segment
            Analytics.track('HelpRequested', {
                help_type: btn.text
            })

            //  If we have a link, then go to it
            if (link) window.open(link, this.isApp ? '_system' : '_blank')
            //  If button has an id attached, it's a custom css selector so close help modal
            else if (btn.id) return this.$store.commit('helpModalSet', false)
            //  If button has a route attached, route in-app
            else if (btn.route) return this.$router.push(btn.route)
            //  Else, we do NOT have a link so this is most likely for intercom
            else this.popIntercomMessenger()
        },
        outClick(e): void {
            // Used for detecting clicks outside of the help modal
            // If there is an out click, we want to close the help modal

            //  Cast our target to an HTML element
            const target = e.target as HTMLElement

            //Grab the help-button element
            const helpButton = document.getElementById('help-button')

            //  Check if click is within the helpButton
            const condition = helpButton.contains(target)

            // If true, do Nothing
            if (condition) {
                return
            }

            // Grab the helpModal element
            const helpModal = document.getElementById('helpModal')

            //  Check if click is within the helpModal
            const helpModalCondition = helpModal.contains(target)

            // If true, do nothing
            if (helpModalCondition) {
                return
            }

            // Else, close the help modal component
            this.$store.commit('helpModalSet', false)
        },
        popIntercomMessenger(): void {
            // Close help modal component
            this.$store.commit('helpModalSet', false)

            //  @ts-ignore If we are on the mobile app, then call our Cordova plugin
            if (this.isApp) intercom.displayMessenger()
            // Pops the intercom messenger through the id bound to the hidden span element
            else window.popSupportMessenger()
        },
        schedulingRouting(): void {
            // If user is trialing, we send them to a different scheduling link
            window.open(
                `${
                    this.subscription.status == 'trialing'
                        ? 'https://calendly.com/d/cqdk-krr-g3n/messagedesk-account-meeting'
                        : 'https://calendly.com/d/cqdk-krr-g3n/messagedesk-account-meeting'
                }`,
                this.isApp ? '_system' : '_blank'
            )
        }
    }
})
